import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "./assets/main.css";

// PWA install prompt — capture early, before any component mounts
window.deferredPrompt = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.deferredPrompt = e;
  localStorage.setItem("pwa_installed", "false");
});
window.addEventListener("appinstalled", () => {
  localStorage.setItem("pwa_installed", "true");
  window.deferredPrompt = null;
});

// 1. Importy potřebné pro kontrolu přihlášení
import { auth } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";

let app;

// 2. Čekáme na inicializaci Firebase Auth
onAuthStateChanged(auth, () => {
  // 3. Aplikaci vytvoříme a připojíme (mount) pouze jednou
  //    a to až ve chvíli, kdy víme, jestli je uživatel přihlášen nebo ne.
  if (!app) {
    app = createApp(App);
    app.use(router);
    app.mount("#app");
  }
});
